<template>
    <p :class="displayClasses" v-html="displayValue"></p>
</template>
<script>
import { defineComponent } from "@vue/runtime-core";

export default defineComponent({
    name: "DateValue",
    computed: {
        displayValue() {
                return this.params.value;
        },
        displayClasses() {
            
            if(this.params.value.includes("GREEN")) return "text-green-500 font-bold";
            else if(this.params.value.includes("AMBER")) return "text-orange-500 font-bold";
            else if(this.params.value.includes("RED")) return "text-red-500 font-bold";
            else return "";
        },
    },
});
</script>
